var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { DataGridFoot } from '../elements/data-grid-foot';
import { DataGridHead } from '../elements/data-grid-head';
var cls = classNames('entity-data-grid');
export var DataGridDefaultProps = {
  showBorder: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    overflow-y: auto;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  "], ["\n    ", "\n    overflow-y: auto;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  "])), function (_a) {
    var showBorder = _a.showBorder;
    return showBorder && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border: 1px solid ", ";\n    "], ["\n      border: 1px solid ", ";\n    "])), theme.COLOR('line-semi-subtle'));
  })
});
var TableStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    border-collapse: collapse;\n    height: 100%;\n    min-width: 100%;\n  "], ["\n    border-collapse: collapse;\n    height: 100%;\n    min-width: 100%;\n  "])))
});
var HeadStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var FootStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'DataGrid',
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Table: styled.table(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), TableStyles),
  Head: styled(DataGridHead)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), HeadStyles),
  Body: styled.tbody(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Foot: styled(DataGridFoot)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), FootStyles)
};
export var DataGrid = function (props) {
  var componentProps = useComponentProps(My.NAME, DataGridDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    head = componentProps.head,
    foot = componentProps.foot,
    showBorder = componentProps.showBorder,
    footOnClick = componentProps.footOnClick,
    footColSpan = componentProps.footColSpan;
  return React.createElement(My.Container, {
    showBorder: showBorder,
    className: cls.name(className)
  }, React.createElement(My.Table, null, React.createElement(My.Head, null, head), React.createElement(My.Body, null, children), foot && React.createElement(My.Foot, {
    onClick: footOnClick,
    colSpan: footColSpan
  }, foot)));
};
DataGrid.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;